import React from 'react';
export function Guarantee() {
  return <section className="bg-white py-12 px-6" data-id="element-137">
      <div className="max-w-md mx-auto text-center space-y-6" data-id="element-138">
        <div className="text-6xl" data-id="element-139">🛡️</div>

        <h2 className="text-2xl font-bold text-navy" data-id="element-140">
          Garantía 7 días — Sin preguntas
        </h2>

        <p className="text-[15px] text-navy/80 leading-relaxed" data-id="element-141">
          Descargás el kit. Lo usás. Si en 7 días no es lo que esperabas, te
          devolvemos el 100% sin formularios, sin drama.
        </p>

        <div className="inline-block bg-teal/10 border border-teal/30 text-teal px-4 py-2 rounded-full text-sm font-semibold" data-id="element-142">
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </section>;
}